import { render, staticRenderFns } from "./SummaryList.vue?vue&type=template&id=024994b8&scoped=true&"
import script from "./SummaryList.vue?vue&type=script&lang=js&"
export * from "./SummaryList.vue?vue&type=script&lang=js&"
import style0 from "./SummaryList.vue?vue&type=style&index=0&id=024994b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024994b8",
  null
  
)

export default component.exports